import React from 'react';
import Header from '../../Header/Header';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCogs, FaPlus, FaTruck, FaUser } from 'react-icons/fa';

const BecomeASeller = () => {
  return (
    <div className="font-sans bg-gray-200 min-h-screen">
      <Header />
      <div className="relative w-full bg-cover bg-center h-96 sm:h-72 md:h-80" style={{ backgroundImage: 'url(assets/rectangle.png)' }}>
        <div className="absolute inset-0 bg-green-900 bg-opacity-50 flex flex-col justify-center items-start p-6 sm:p-8 md:p-12">
          <h1 className="text-white text-2xl sm:text-3xl md:text-5xl font-bold mb-4">Launch your online selling<br /> Business with confidence</h1>
          <Link to="/seller-sign-up" className="inline-block bg-green-500 text-white py-2 px-6 rounded-full text-lg hover:bg-green-700 transition">
            Start Selling
          </Link>
        </div>
        <div className="absolute inset-y-0 right-0 flex items-center">
          <img src="assets/sellerPic.png" alt="Seller" className="h-full object-cover" />
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-center p-6 sm:p-8 md:p-12 bg-gray-200">
        <div className="w-full md:w-1/2 p-4">
          <img src="assets/becomeSellerPic1.png" alt="Become a Seller" className="w-full h-auto object-cover" />
        </div>
        <div className="w-full md:w-1/2 p-4">
          <h1 className="text-black text-3xl sm:text-2xl md:text-3xl font-bold mb-2">Your one-stop shop for quality products</h1>
          <p className="text-gray-700 mb-2">Discover top quality products in one place. Our curated selection offers high-resolution images, descriptions, and easy navigation to ensure a seamless shopping experience for all your needs.</p>
        </div>
      </div>

      {/* Payment Solution Section */}
      <div className="flex flex-col md:flex-row items-center p-6 sm:p-8 md:p-12 bg-gray-200">
        <div className="w-full md:w-1/2 p-4">
          <h1 className="text-black text-3xl sm:text-2xl md:text-3xl font-bold mb-2">Simplified Payment Solution</h1>
          <p className="text-gray-900 mb-2">Experience effortless and transparent payment management with our streamlined system. Simplify transactions, gain clear insight, and confidently focus on scaling your business.</p>
        </div>
        <div className="w-full md:w-1/2 p-4">
          <img src="assets/becomeSellerPic2.png" alt="Become a Seller" className="w-full h-auto object-cover" />
        </div>
      </div>

      {/* Brand Success Section */}
      <div className="flex flex-col md:flex-row items-center p-6 sm:p-8 md:p-12 bg-gray-200">
        <div className="w-full md:w-1/2 p-4">
          <img src="assets/becomeSellerPic3.png" alt="Become a Seller" className="w-full h-auto object-cover" />
        </div>
        <div className="w-full md:w-1/2 p-4">
          <h1 className="text-green-500 text-3xl sm:text-2xl md:text-3xl font-bold mb-2">Focus on Your Brand's Success</h1>
          <p className="text-gray-900 mb-2">Focus on your brand's success. We offer tailored solutions and expert support to help your brand thrive. Our commitment to innovation and growth ensures we drive your business forward, maximizing your brand's potential.</p>
        </div>
      </div>

      {/* Customer Review Section */}
      <div className="flex flex-col items-center p-6 sm:p-8 md:p-12 bg-gray-200">
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 w-full md:w-9/10 lg:w-9/10 flex flex-col md:flex-row">
          <div className="w-full md:w-1/2 p-4">
            <h2 className="text-green-500 text-xl font-bold mb-2">Resia</h2>
            <div>
              <h3 className="text-black font-bold mb-2">What customers say about us</h3>
              <div className="flex items-center mb-2">
                <span className="text-yellow-500 text-xl">★★★★☆</span>
              </div>
              <p className="text-gray-700 mb-2">Grow your brand and evaluate your product with Resia. Our innovative strategies and expert support drive success, helping to expand your market presence.</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 p-4">
            <img src="assets/becomeSellerPic4.png" alt="Customer Review" className="w-full h-auto object-cover" />
          </div>
        </div>
      </div>

      {/* How to Start Your Business Section */}


      {/* How to Start Your Business Section */}
<div className="flex flex-col items-center p-6 sm:p-8 md:p-12 bg-gray-200">
  <h2 className="text-black text-3xl sm:text-2xl md:text-3xl font-bold mb-6">How to Start Your Online Business</h2>
  <div className="flex flex-col md:flex-row justify-center items-center w-full max-w-6xl mx-auto">
    {/* Step 1 */}
    <div className="flex flex-col md:flex-row items-center mb-8 md:mb-0">
      <div className="flex flex-col items-center mx-4">
        <div className="bg-green-500 text-white p-4 rounded-full mb-2">
          <FaUser className="text-3xl" />
        </div>
        <p className="text-center">Create your account</p>
      </div>
      <div className="mx-4 my-4 md:my-0">
        <FaArrowRight className="text-xl" />
      </div>
    </div>

    {/* Step 2 */}
    <div className="flex flex-col md:flex-row items-center mb-8 md:mb-0">
      <div className="flex flex-col items-center mx-4">
        <div className="bg-green-500 text-white p-4 rounded-full mb-2">
          <FaCogs className="text-3xl" />
        </div>
        <p className="text-center">Select your storage and shipping options</p>
      </div>
      <div className="mx-4 my-4 md:my-0">
        <FaArrowRight className="text-xl" />
      </div>
    </div>

    {/* Step 3 */}
    <div className="flex flex-col md:flex-row items-center mb-8 md:mb-0">
      <div className="flex flex-col items-center mx-4">
        <div className="bg-green-500 text-white p-4 rounded-full mb-2">
          <FaPlus className="text-3xl" />
        </div>
        <p className="text-center">Add your Product to our platform</p>
      </div>
      <div className="mx-4 my-4 md:my-0">
        <FaArrowRight className="text-xl" />
      </div>
    </div>

    {/* Step 4 */}
    <div className="flex flex-col items-center mx-4">
      <div className="bg-green-500 text-white p-4 rounded-full mb-2">
        <FaTruck className="text-3xl" />
      </div>
      <p className="text-center">Deliver order and collect payment</p>
    </div>
  </div>
</div>
      {/* <div className="flex flex-col items-center p-6 sm:p-8 md:p-12 bg-gray-200">
        <h2 className="text-black text-3xl sm:text-2xl md:text-3xl font-bold mb-6">How to Start Your Online Business</h2>
        <div className="flex flex-wrap justify-between w-full max-w-4xl mx-auto items-center">
          <div className="flex flex-col items-center mb-4 md:mb-0">
            <div className="bg-green-500 text-white p-4 rounded-full mb-2">
              <FaUser className="text-3xl" />
            </div>
            <p>Create your account</p>
          </div>
          <div className="flex items-center mx-8 mb-4 md:mb-0">
            <FaArrowRight className="text-xl" />
          </div>
          <div className="flex flex-col items-center mb-4 md:mb-0">
            <div className="bg-green-500 text-white p-4 rounded-full mb-2">
              <FaCogs className="text-3xl" />
            </div>
            <p>Select your storage and shipping options</p>
          </div>
          <div className="flex items-center mx-8 mb-4 md:mb-0">
            <FaArrowRight className="text-xl" />
          </div>

          <div className="flex flex-col items-center mb-4 md:mb-0">
            <div className="bg-green-500 text-white p-4 rounded-full mb-2">
              <FaPlus className="text-3xl" />
            </div>
            <p>Add your Product to our platform</p>
          </div>
          <div className="flex items-center mx-8 mb-4 md:mb-0">
            <FaArrowRight className="text-xl" />
          </div>
          <div className="flex flex-col items-center">
            <div className="bg-green-500 text-white p-4 rounded-full mb-2">
              <FaTruck className="text-3xl" />
            </div>
            <p>Deliver order and collect payment</p>
          </div>
        </div>
      </div> */}

      {/* Final Call to Action */}
      <div className="relative w-full">
        <img src="assets/becomeSellerPic6.png" alt="Become a Seller" className="w-full h-auto object-cover" />
        <div className="absolute inset-0 bg-white bg-opacity-60 flex flex-col justify-center items-center p-6 sm:p-8 md:p-12">
          <h2 className="text-black text-3xl sm:text-4xl font-bold mb-4 text-center">Let's Become an Online Seller & Grow Your Business</h2>
          <Link to="/seller-sign-up" className="inline-block bg-green-500 text-white py-2 px-6 rounded-full text-lg hover:bg-green-700 transition">
            Start Selling
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BecomeASeller;
